import React from "react";
import {
  Users,
  BookOpen,
  Palette,
  UserPlus,
  Heart,
  Layers,
  LayoutDashboard,
} from "lucide-react";
import styles from "./card.module.scss";

const ICON_BY_IMAGE = {
  users: Users,
  books: BookOpen,
  category: Palette,
  feedback: UserPlus,
  authors: Heart,
  collection: Layers,
};

export default function Card(props) {
  const { label, count, image, variant } = props;

  const IconComponent = ICON_BY_IMAGE[image] ?? LayoutDashboard;

  const cardClass = variant === "dark" ? `${styles.Card} ${styles.cardDark}` : styles.Card;
  const isCategoryIcon = image === "category";

  return (
    <div className={cardClass}>
      <div className={styles.cardHeader}>
        <div className={styles.iconWrapper}>
          <IconComponent
            className={`${styles.iconImg}${isCategoryIcon ? ` ${styles.iconImgCategory}` : ""}`}
            size={28}
            strokeWidth={2}
            aria-hidden
          />
        </div>
        <div className={styles.cardContent}>
          <h3 className={styles.count}>{count}</h3>
          <p className={styles.title}>{label}</p>
        </div>
      </div>
    </div>
  );
}
